//Parroquia Miranda
const munAcevedoMiranda = [
  'Caucagua',
  'Aragüita',
  'Arévalo González',
  'Capaya',
  'El Café',
  'Marizapa',
  'Panaquire',
  'Ribas',
];
const munAndrésBelloMiranda = ['San José de Barlovento', 'Cumbo'];
const munBaruta = [
  'Nuestra Señora del Rosario de Baruta',
  'El Cafetal',
  'Las Minas de Baruta',
];
const munBrión = ['Higuerote', 'Curiepe', 'Tacarigua'];
const munBuroz = ['Mamporal'];
const munCarrizal = ['Carrizal'];
const munChacao = ['Chacao'];
const munCristóbalRojas = ['Charallave', 'Las Brisas'];
const munElHatillo = ['El Hatillo'];
const munBolivarianoGuaicaipuro = [
  'Los Teques ',
  'Altagracia de La Montaña ',
  'Cecilio Acosta ',
  'El Jarillo ',
  'Paracotos ',
  'San Pedro ',
  'Tácata ',
];
const munIndependenciaMiranda = ['Santa Teresa del Tuy', 'El Cartanal'];
const munLander = ['Ocumare del Tuy', 'La Democracia', 'Santa Bárbara'];
const munLosSalias = ['San Antonio de Los Altos'];
const munPáez = [
  'Río Chico',
  'El Guapo',
  'Tacarigua de La Laguna',
  'Paparo',
  'San Fernando del Guapo',
];
const munPazCastillo = ['Santa Lucía'];
const munPedroGual = ['Cúpira', 'Machurucuto'];
const munPlaza = ['Guarenas'];
const munSimónBolívar = ['San Francisco de Yare', 'San Antonio de Yare'];
const munSucreMiranda = [
  'Petare',
  'Caucagüita',
  'Fila de Mariche',
  'La Dolorita',
  'Leoncio Martínez',
];
const munUrdanetaMiranda = ['Cúa', 'Nueva Cúa'];
const munZamoraMiranda = ['Guatire', 'Bolívar'];

export const esMiranda = [
  {
    municipio: 'Acevedo Miranda',
    parroquias: munAcevedoMiranda,
  },
  {
    municipio: 'Andrés Bello Miranda',
    parroquias: munAndrésBelloMiranda,
  },
  {
    municipio: 'Baruta',
    parroquias: munBaruta,
  },
  {
    municipio: 'Brión',
    parroquias: munBrión,
  },
  {
    municipio: 'Buroz',
    parroquias: munBuroz,
  },
  {
    municipio: 'Carrizal',
    parroquias: munCarrizal,
  },
  {
    municipio: 'Chacao',
    parroquias: munChacao,
  },
  {
    municipio: 'Cristóbal Rojas',
    parroquias: munCristóbalRojas,
  },
  {
    municipio: 'El Hatillo',
    parroquias: munElHatillo,
  },
  {
    municipio: 'Bolivariano Guaicaipuro',
    parroquias: munBolivarianoGuaicaipuro,
  },
  {
    municipio: 'Independencia Miranda',
    parroquias: munIndependenciaMiranda,
  },
  {
    municipio: 'Lander',
    parroquias: munLander,
  },
  {
    municipio: 'Los Salias',
    parroquias: munLosSalias,
  },
  {
    municipio: 'Páez',
    parroquias: munPáez,
  },
  {
    municipio: 'Paz Castillo',
    parroquias: munPazCastillo,
  },
  {
    municipio: 'Pedro Gual',
    parroquias: munPedroGual,
  },
  {
    municipio: 'Plaza',
    parroquias: munPlaza,
  },
  {
    municipio: 'Simón Bolívar',
    parroquias: munSimónBolívar,
  },
  {
    municipio: 'Sucre Miranda',
    parroquias: munSucreMiranda,
  },
  {
    municipio: 'Urdaneta',
    parroquias: munUrdanetaMiranda,
  },
  {
    municipio: 'Zamora',
    parroquias: munZamoraMiranda,
  },
];
